const baseURL = 'https://catalogos.compuservictecnologia.com/';

export default baseURL;
